/**
 * P41 · PUBLIC route for guardian consent (guest-first, no
 * account): `/guardian-consent?token=<token>`.
 *
 * Lives OUTSIDE the `/u/<n>` tree —and that's why it's on both allowlists, the
 * root's `beforeLoad` and `u-router`'s— because the link is opened from the
 * email, on a device that may have no session at all. Rewriting it to
 * `/u/0/guardian-consent` would send the guardian to the app's boot screen instead
 * of the decision being asked of them.
 *
 * The token travels in the query, not the path (unlike
 * `/verify/$certId`) because that's how the server builds it
 * (`handlers::consent::request_handler`): a single place decides the shape of the
 * link, and it's the same place that issues it.
 */
import { createRoute, useSearch } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { GuardianConsentPublicView } from "@/features/academy/components/consent/guardian-consent-public-view";

function GuardianConsentPage() {
  const search = useSearch({ from: guardianConsentRoute.id });
  return <GuardianConsentPublicView token={search().token ?? ""} />;
}

export const guardianConsentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/guardian-consent",
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: GuardianConsentPage,
});
